import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { action, computed, autorun, observable } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import inject from 'helpers/inject'

import AuthService from 'services/auth'
import RouterService from 'services/router'

import createAccount from 'tasks/createAccount'

import FormInput from 'components/forms/FormInput'
import AsyncButton from 'components/AsyncButton'

import formField from 'helpers/formField'

import styles from 'styles/components/RegistrationForm'

@withStyles(styles)
@observer
export default class RegistrationForm extends Component {

  static contextTypes = {
    swipeableViews: PropTypes.object.isRequired,
  }

  auth = inject(AuthService)
  router = inject(RouterService)

  @observable error

  fields = [

    formField({
      value: '',
      label: 'Адрес электронной почты',
      type: 'email',
      name: 'email',
      validations: {
        presence: true,
        email: true
      }
    }),

    formField({
      value: '',
      label: 'Пароль',
      type: 'password',
      name: 'password',
      validations: {
        presence: true,
        length: { minimum: 6, tooShort: 'Пароль должен содержать не менее 6 символов' }
      }
    }),

    formField({
      value: '',
      label: 'Имя',
      name: 'firstName',
      validations: {
        presence: true,
        format: { pattern: '[А-Я-Ё]+', flags: 'gi', message: 'Поле может содержать только русские буквы'}
      }
    }),

    formField({
      value: '',
      label: 'Фамилия',
      name: 'lastName',
      validations: {
        presence: true,
        format: { pattern: '[А-Я-Ё]+', flags: 'gi', message: 'Поле может содержать только русские буквы'}
      }
    })

  ]

  @computed
  get hasErrors() {
    return this.fields.filter(field => field.hasErrors).length > 0
  }

  componentDidMount() {
    autorun(() => {
      this.fields.filter(field => field.hasErrors);
      window.setTimeout(() => {
        this.context.swipeableViews.slideUpdateHeight();
      }, 100)
    })
  }

  render() {
    const { classes } = this.props

    return (
      <form noValidate onSubmit={ this.handleSubmit } className={ classes.root } >

        { this.fields.map(( field, index ) => (
          <FormInput
            field={ field }
            key={ index }
            TextFieldProps={{
              fullWidth: true
            }}
          />
        ))}

        <div className={ classes.actions } >
          <AsyncButton
            action={ this.handleSubmit }
            label='Зарегистрироваться'
            processingLabel=''
            successLabel='Успешно!'
            ButtonProps={{
              fullWidth: true,
              raised: true,
              color: 'primary'
            }}
          />

        </div>

      </form>
    )
  }

  @action.bound
  async handleSubmit() {
    if (!this.validateForm()) throw new Error()
    const email = this.fields.find(field => field.name === 'email').value
    const password = this.fields.find(field => field.name === 'password').value
    const firstName = this.fields.find(field => field.name === 'firstName').value
    const lastName = this.fields.find(field => field.name === 'lastName').value
    await createAccount.perform({ email, password, firstName, lastName })
    await this.auth.authorize(email, password)
    this.router.transitionTo()
  }

  @action.bound
  validateForm() {
    this.fields.forEach(field => field.validate())
    return !this.hasErrors
  }

}



// WEBPACK FOOTER //
// ./src/components/RegistrationForm.js